// extracted by mini-css-extract-plugin
export default {"TenantDepositDetails":"TenantDepositDetails_TenantDepositDetails__7PVQ0","DoneIcon":"TenantDepositDetails_DoneIcon__pCLBC"};